import React from 'react'

import BodyText from 'components/Luxkit/Typography/BodyText'
import useFlightItemConfirmationCodes from 'tripPlanner/hooks/confirmationCodes/useFlightItemConfirmationCodes'
import { FlightItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: FlightItem
}

export function FlightBookingInfo({ item }: Props) {
  const confCode = useFlightItemConfirmationCodes(item)

  if (!confCode.hasCode) {
    return null
  }

  return (
    <div>
      <BodyText weight="semi-bold" variant="medium">
        {confCode.label}
      </BodyText>
      <BodyText variant="medium">{confCode.codeString}</BodyText>
    </div>
  )
}
